import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import Select from '@/components/forms/Select';
import { useDropdown } from '@/hooks/useDropdown';
import { useDynamicLocale } from '@/hoslog-intl';
import { z } from 'zod';
import useAssignCommission from './hooks/useAssignCommission';
import { useAttributes } from '@/hooks/useAttributes';

const assignCommissionFormSchema = z.object({
  location: z.string().refine((value) => value !== '' && value !== 'default', {
    message: 'common.form.validation.required',
  }),
  club: z.string().refine((value) => value !== '' && value !== 'default', {
    message: 'common.form.validation.required',
  }),
  newCommissionCategory: z.string().refine((value) => value !== '' && value !== 'default', {
    message: 'common.form.validation.required',
  }),
});

export const AssignCommissionForm = () => {
  const form = useForm({ schema: assignCommissionFormSchema, mode: 'onBlur' });

  const locationValue = form.watch('location');
  const clubValue = form.watch('club');
  const { data: locationOptions = [] } = useDropdown('Location');
  const { data: clubOptions = [] } = useAttributes('ClubByLocation', locationValue);
  const { data: currentCategoryOptions = [] } = useDropdown('ComCurrentCategory', clubValue);
  const { data: newCommissionCategoryOptions = [] } = useDropdown('ComCategory');

  const currentCommissionChargeValue = clubValue ? (currentCategoryOptions[0]?.label ?? '') : '';

  const { t } = useDynamicLocale();
  const { mutateAsync } = useAssignCommission();
  return (
    <Form
      form={form}
      onSubmit={async (data) => {
        await mutateAsync({
          agentId: data.club,
          categoryId: data.newCommissionCategory,
        });
      }}
    >
      <div className="flex flex-col gap-4.5">
        <div>
          <Select
            label="configurationManagement.commissions.assignCommissionModal.location"
            {...form.register('location')}
            placeholder={t('configurationManagement.commissions.assignCommissionModal.selectLocation')}
            options={locationOptions}
          />
        </div>
        <Select
          label="configurationManagement.commissions.assignCommissionModal.club"
          {...form.register('club')}
          disabled={!locationValue}
          options={clubOptions}
          placeholder={t('configurationManagement.commissions.assignCommissionModal.selectClub')}
        />
        <Input
          name="currentCommissionCharge"
          label="configurationManagement.commissions.assignCommissionModal.currentCommissionCharge"
          forceRequired
          disabled
          placeholder={t('configurationManagement.commissions.assignCommissionModal.currentCategoryCharge')}
          value={currentCommissionChargeValue}
        />
        <Select
          label="configurationManagement.commissions.assignCommissionModal.newCommissionCategory"
          {...form.register('newCommissionCategory')}
          options={newCommissionCategoryOptions}
          placeholder={t('configurationManagement.commissions.assignCommissionModal.selectCommissionCategory')}
        />
      </div>
    </Form>
  );
};
